import styled from 'styled-components';
import { Responsive, Segment } from 'semantic-ui-react';

const styles = {
  containerDesktop: {
    display: 'flex',
    height: '64px',
    alignItems: 'center',
    padding: '0px 16px 0px 16px',
  },
  containerMobile: {
    display: 'flex',
    height: '64px',
    alignItems: 'center',
    padding: '0px 12px 0px 12px',
  },
  title: {
    fontSize: '14px',
    fontWeight: '500',
    paddingLeft: '8px',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: '-0.12px',
  },
};
Object.freeze(styles);

function UserRegisterIcon(props) {
  const { title } = props;

  const titleColour = props.textColour ?? 'white'; // eslint-disable-line react/destructuring-assignment

  return (
    <Container>
      <Responsive as={Segment} minWidth={601} style={styles.containerDesktop}>
        <svg
          fill={titleColour}
          height="24px"
          width="24px"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
        >
          <path d="M32 14h-4v-4h-2v4h-4v2h4v4h2v-4h4v-2zM12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7z" />
        </svg>
        <p style={{ ...styles.title, color: titleColour }}>{title}</p>
      </Responsive>
      <Responsive as={Segment} maxWidth={600} style={styles.containerMobile}>
        <svg
          fill={titleColour}
          height="24px"
          width="24px"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
        >
          <path d="M32 14h-4v-4h-2v4h-4v2h4v4h2v-4h4v-2zM12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7z" />
        </svg>
      </Responsive>
    </Container>
  );
}

const Container = styled.div`
  :hover {
    backgroundColor: "rgb(255, 255, 255, .5)"
  }
`;

export default UserRegisterIcon;
